import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgNavigationComponent } from './atg-navigation.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { GenericLinkModule, IconModule, MediaModule, NavigationModule } from '@spartacus/storefront';

@NgModule({
  declarations: [AtgNavigationComponent],
  imports: [
    CommonModule,
    NavigationModule,
    GenericLinkModule,
    IconModule,
    I18nModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NavigationComponent: {
          component: () => import('./atg-navigation.component').then((c) => c.AtgNavigationComponent),
        },
      },
    } as CmsConfig),
  ],
  exports: [AtgNavigationComponent],
})
export class AtgNavigationModule {}
